<template>
  <div class="home">
    <h1>Element Plus Dark</h1>
    <h2>—— Element Plus 非官方的暗黑模式解决方案 ——</h2>
    <div class="margin-top-50">
      <span>v1.0.0 发布于2022年2月17日</span>
      <span class="margin-left-20">适用于 Element Plus v2.0+</span>
    </div>
    <div class="margin-top-50">
      <span>作者：杨亮</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style lang="scss">
.home {
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
